import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { key: String }

  connect() {
    try {
      const state = window.sessionStorage.getItem(this.storageKey)
      if (state !== null) this.element.open = state === "open"
    } catch {
      // Keep the HTML default when browser storage is unavailable.
    }
  }

  remember() {
    try {
      window.sessionStorage.setItem(this.storageKey, this.element.open ? "open" : "closed")
    } catch {
      // The disclosure still works without remembering its state.
    }
  }

  get storageKey() {
    return `disclosure-state:${this.keyValue}`
  }
}
